var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("input", {
    ref: "input",
    staticClass: "form-control",
    attrs: {
      type: _vm.type,
      name: _vm.name,
      placeholder: _vm.placeholder,
      disabled: _vm.disabled,
      tabindex: _vm.tabindex,
      "data-parsley-maxlength": _vm.maxLength,
      pattern: _vm.pattern,
    },
    domProps: { value: _vm.value },
    on: {
      change: _vm.handleChange,
      focusout: _vm.handleFocusOut,
      input: _vm.handleInput,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }